"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToAfterLevelMessageQueue = exports.sendMessageToAll = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EDiveAlterType = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var diveCrew_movable_sidecar_1 = require("@voyage/crew/diveCrew_movable-sidecar");
var EDiveAlterType;
(function (EDiveAlterType) {
    EDiveAlterType[EDiveAlterType["CrewEnterLevel"] = 1] = "CrewEnterLevel";
    EDiveAlterType[EDiveAlterType["CrewDestroy"] = 2] = "CrewDestroy";
})(EDiveAlterType = exports.EDiveAlterType || (exports.EDiveAlterType = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Dive_AlterEntity;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.alterType);
    messageWriter_sidecar_1.messageWriter.write32(m, d.id);
    messageWriter_sidecar_1.messageWriter.write16(m, d.i);
    messageWriter_sidecar_1.messageWriter.write16(m, d.j);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        alterType: messageWriter_sidecar_1.messageWriter.read8(m),
        id: messageWriter_sidecar_1.messageWriter.read32(m),
        i: messageWriter_sidecar_1.messageWriter.read16(m),
        j: messageWriter_sidecar_1.messageWriter.read16(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        alterType: EDiveAlterType.CrewEnterLevel,
        id: 123,
        i: 456,
        j: 789,
    };
    messageWriter_sidecar_1.messageWriter.test('alter-entity', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    console.log('alter-entity', 'processing', msg);
    var alterType = msg.alterType;
    if (alterType === EDiveAlterType.CrewEnterLevel) {
        var crew = diveCrew_sidecar_1.diveCrew.findById(msg.id);
        if (!crew) {
            console.warn('alter-entity', 'Crew not found', msg.id);
        }
        if (crew) {
            if (crew.isUpStairs) {
                crew.isUpStairs = false;
                crew.isDownStairs = false;
                crew.stairsFadeTimeSeconds = 1;
            }
            console.log('alter-entity', 'moving crew', msg);
            diveCrew_movable_sidecar_1.diveCrew_movable.instantMoveToIJ(crew, { i: msg.i, j: msg.j });
        }
    }
    if (alterType === EDiveAlterType.CrewDestroy) {
        var crew = diveCrew_sidecar_1.diveCrew.findById(msg.id);
        if (!crew) {
            console.warn('alter-entity', 'Crew not found', msg.id);
        }
        if (crew) {
            console.log('alter-entity', 'destroying crew', msg);
            diveCrew_sidecar_1.diveCrew.kill(crew);
        }
    }
}
exports.process = process;
function sendMessageToAll(msg) {
    websockets_sidecar_1.websockets._sendMessageToAll(write, msg, true);
}
exports.sendMessageToAll = sendMessageToAll;
function addToAfterLevelMessageQueue(msg) {
    diveSimulationManager_sidecar_1.diveSimulationManager.addToAfterLevelMessageQueue(msg);
}
exports.addToAfterLevelMessageQueue = addToAfterLevelMessageQueue;
